import { lazy } from "@loadable/component";
import { Suspense } from "react";
import { ErrorBoundary } from "@sentry/react";
import { DHSApprovalDetailLoading } from "./DHSApprovalDetail.loading";
import { useFeatureFlag } from "../FeatureFlag/FeatureFlagsProvider";
import type { DHSApprovalDetailProps } from "./DHSApprovalDetail";

export const DHSApprovalDetailLoadable = lazy(() => import("./DHSApprovalDetail"));

export const DHSApprovalDetail = (props: DHSApprovalDetailProps) => {
  const dhsEnabled = useFeatureFlag("FEATURE_DHS_INTEGRATION");
  const { user } = props;

  // Gated here so the auto-firing query never mounts when the feature is off, including via deep links.
  if (!dhsEnabled || !user?.permissions?.viewDhsApprovals) return null;

  return (
    <ErrorBoundary fallback={<DHSApprovalDetailLoading />}>
      <Suspense fallback={<DHSApprovalDetailLoading />}>
        <DHSApprovalDetailLoadable {...props} />
      </Suspense>
    </ErrorBoundary>
  );
};
